import { AuditDto } from '@pf/platform-wms/domain';

function auditMatchesZoneFilter(audit: AuditDto, zoneIds: string[]): boolean {
    const zoneId = audit.inventoryBundle?.container?.slot?.zone?.id;
    return !!zoneId && zoneIds.includes(zoneId);
}

export function filterAuditsByZones(
    audits: AuditDto[] | undefined | null,
    zoneIds: string[]
): AuditDto[] {
    const list = audits ?? [];
    if (!zoneIds?.length) {
        return list;
    }
    return list.filter(audit => auditMatchesZoneFilter(audit, zoneIds));
}

export function taskHasAuditInZones(
    audits: AuditDto[] | undefined | null,
    zoneIds: string[]
): boolean {
    if (!zoneIds?.length) {
        return true;
    }
    return (audits ?? []).some(audit => auditMatchesZoneFilter(audit, zoneIds));
}
